import React from "react";
import "./Footer.scss";
import GlobalData from '../../data/global.js';
import OutputHTML from '../../helpers/OutputHTML.js';

const Footer = () => {
    let footer = GlobalData.footer;
    return (
        <div className={`footer`}>
            <div className={`footer__left_container`}>
                <div className={`footer__left_container__content_container`}>
                    <p >
                        <span dangerouslySetInnerHTML={ OutputHTML( footer.copyright.copy)}></span> 
                        <a href={footer.copyright.URL} target="_blank" rel="noreferrer"> <span dangerouslySetInnerHTML={ OutputHTML( footer.copyright.readMore)}></span></a>
                    </p>
                </div>
            </div>
            <div className={`footer__right_container`}>
                <div className={`footer__right_container__cookies_policy`}>
                    <a href={footer.cookies.cookieURL} target="_blank" rel="noreferrer">
                        <p dangerouslySetInnerHTML={ OutputHTML( footer.cookies.cookieCopy)}></p>
                    </a>
                </div>
                <div className={`footer__right_container__ad_choices`}>
                    <a href={footer.cookies.adChoicesURL} target="_blank" rel="noreferrer">
                        <p dangerouslySetInnerHTML={ OutputHTML( footer.cookies.adChoices)}></p>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Footer